module.exports = __webpack_public_path__ + "img/Working_Paper-High_Road_Labor_and_Renewable_Energy-PUBLIC_RELEASE-4-13-21.pdf";